<template>
  <div>
    <FormaOkvir
      v-if="noviIzgled"
      ref="okvir"
      :greske="greskeVidljive"
      :upozorenja="validacija.upozorenja"
      :izmijenjena="izmijenjena"
      :redoslijed="redoslijed"
      :poruka="porukaServera"
    >
      <FormaTraka
        slot="traka"
        :naslov="naslovTrake"
        :podnaslov="podnaslovTrake"
        :inicijali="inicijali"
        :spremanje="spremanje"
        spremi-oznaka="Spremi"
        odustani-oznaka="Odustani"
        @spremi="spremiNovi"
        @odustani="odustani"
        @stari-obrazac="promijeniIzgled('stari')"
      >
        <FormaTabovi slot="tabovi" :tabovi="tabovi" />
      </FormaTraka>

      <div class="stupci">
        <!-- LIJEVO -->
        <div>
          <FormaKartica id="k-osobni" naslov="Osobni podaci" :kljucevi="osobniKljucevi" :model="employee">
            <div class="mreza">
              <FormaPolje ime="First" :label="oz('First')" obavezno>
                <input type="text" v-model="employee.First" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="Last" :label="oz('Last')" obavezno>
                <input type="text" v-model="employee.Last" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="VatID" :label="oz('VatID')" obavezno hint="11 znamenki, provjera kontrolne znamenke (samo upozorenje)">
                <input type="text" v-model="employee.VatID" inputmode="numeric" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="DateOfBirht" :label="oz('DateOfBirht')" obavezno>
                <input type="date" v-model="employee.DateOfBirht" />
              </FormaPolje>
              <FormaPolje ime="Gender" :label="oz('Gender')">
                <input type="text" v-model="employee.Gender" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="PersonalID1" :label="oz('PersonalID1')">
                <input type="text" v-model="employee.PersonalID1" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="PersonalID2" :label="oz('PersonalID2')">
                <input type="text" v-model="employee.PersonalID2" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="PlaceOfBirht" :label="oz('PlaceOfBirht')">
                <input type="text" v-model="employee.PlaceOfBirht" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="PlaceOfBirthState" :label="oz('PlaceOfBirthState')">
                <input type="text" v-model="employee.PlaceOfBirthState" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="Foriner" :label="oz('Foriner')">
                <input type="text" v-model="employee.Foriner" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="ForinerLicense" :label="oz('ForinerLicense')">
                <input type="text" v-model="employee.ForinerLicense" autocomplete="off" />
              </FormaPolje>
            </div>
          </FormaKartica>

          <FormaKartica id="k-kontakt" naslov="Kontakt i adresa" :kljucevi="kontaktKljucevi" :model="employee">
            <div class="mreza">
              <FormaPolje ime="eemail" label="Email" obavezno>
                <input type="text" v-model="employee.eemail" inputmode="email" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="phone" label="Telefon" obavezno>
                <input type="text" v-model="employee.phone" inputmode="tel" autocomplete="off" />
              </FormaPolje>
              <FormaPolje class="sve" ime="PlaceOfLive" :label="oz('PlaceOfLive')">
                <input type="text" v-model="employee.PlaceOfLive" autocomplete="off" placeholder="Ulica i broj, poštanski broj, mjesto" />
              </FormaPolje>
            </div>
          </FormaKartica>

          <FormaKartica id="k-ostalo" naslov="Ostalo" dodatak="interna bilješka" sklopiva :otvoreno.sync="otv.ostalo" :kljucevi="ostaloKljucevi" :model="employee">
            <div class="mreza c1">
              <FormaPolje ime="OtherData" :label="oz('OtherData')">
                <textarea v-model="employee.OtherData"></textarea>
              </FormaPolje>
            </div>
          </FormaKartica>
        </div>

        <!-- DESNO -->
        <div>
          <FormaKartica id="k-zaposlenje" naslov="Zaposlenje" :kljucevi="zaposlenjeKljucevi" :model="employee">
            <div class="podnaslov">Status</div>
            <div class="mreza">
              <FormaPolje class="sve" ime="hashtag" :label="oz('hashtag')" obavezno :hint="hashtagHint">
                <button slot="akcija" type="button" class="tekst-gumb" :disabled="!mozePredloziti || hashtagPredlaganje" :title="mozePredloziti ? 'Predloži hashtag iz imena i prezimena' : 'Upiši ime i prezime'" @click="predloziHashtag">
                  {{ hashtagPredlaganje ? 'traži…' : 'Predloži' }}
                </button>
                <input type="text" v-model="employee.hashtag" autocomplete="off" placeholder="#imeprezime" />
                <template slot="info">
                  <div v-if="hashtagStanje.status === 'provjera'" class="pomoc">provjera…</div>
                  <div v-else-if="hashtagStanje.status === 'slobodan'" class="ok">✓ hashtag je slobodan</div>
                  <div v-else-if="hashtagStanje.status === 'ista'" class="up">{{ hashtagStanje.poruka }}</div>
                </template>
              </FormaPolje>
              <FormaPolje ime="Activ" :label="oz('Activ')">
                <label class="sw"><input type="checkbox" v-model="employee.Activ" /><span class="tr"></span><span>da</span></label>
              </FormaPolje>
              <FormaPolje ime="Black" :label="oz('Black')">
                <label class="sw"><input type="checkbox" v-model="employee.Black" /><span class="tr"></span><span>da <small>(isključuje „Aktivno")</small></span></label>
              </FormaPolje>
            </div>

            <div class="podnaslov">Radni odnos</div>
            <div class="mreza">
              <FormaPolje ime="StartInCompany" :label="oz('StartInCompany')">
                <input type="date" v-model="employee.StartInCompany" />
              </FormaPolje>
              <FormaPolje ime="WeeklyWorkHours" :label="oz('WeeklyWorkHours')">
                <input type="text" class="n" v-model="employee.WeeklyWorkHours" inputmode="decimal" />
              </FormaPolje>
              <FormaPolje ime="VrstaRadnogOdnosa" label="Vrsta radnog odnosa" obavezno>
                <select v-model="selectVrstaRadnogOdnosa">
                  <option :value="null">—</option>
                  <option v-for="o in vrstaRadnogOdnosa" :key="o.value" :value="o">{{ o.text }}</option>
                </select>
              </FormaPolje>
              <FormaPolje ime="VrstaRadnogVremena" label="Vrsta radnog vremena" obavezno>
                <select v-model="selectVrstaRadnogVremena">
                  <option :value="null">—</option>
                  <option v-for="o in vrstaRadnogVremena" :key="o.value" :value="o">{{ o.text }}</option>
                </select>
              </FormaPolje>
              <FormaPolje ime="NotWorkingTime" :label="oz('NotWorkingTime')">
                <input type="text" v-model="employee.NotWorkingTime" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="Joppd71Oznaka" label="Staž s povećanim trajanjem (Joppd 7.1)" hint="oznaka 0 ili 1">
                <input type="number" class="n" v-model="employee.Joppd71Oznaka" />
              </FormaPolje>
              <FormaPolje class="sve" ime="WorkHardConditions" :label="oz('WorkHardConditions')">
                <input type="text" v-model="employee.WorkHardConditions" autocomplete="off" />
              </FormaPolje>
            </div>

            <div class="podnaslov">Zanimanje i školovanje</div>
            <div class="mreza">
              <FormaPolje ime="WorkPlace" :label="oz('WorkPlace')">
                <input type="text" v-model="employee.WorkPlace" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="Occupation" :label="oz('Occupation')">
                <input type="text" v-model="employee.Occupation" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="Obrazovanje" label="Obrazovanje" obavezno>
                <select v-model="selectObrazovanje">
                  <option :value="null">—</option>
                  <option v-for="o in obrazovanje" :key="o.value" :value="o">{{ o.text }}</option>
                </select>
              </FormaPolje>
              <FormaPolje ime="Degree" :label="oz('Degree')">
                <input type="text" v-model="employee.Degree" autocomplete="off" placeholder="npr. SSS, VSS" />
              </FormaPolje>
              <FormaPolje class="sve" ime="SpecialKnowledge" :label="oz('SpecialKnowledge')">
                <input type="text" v-model="employee.SpecialKnowledge" autocomplete="off" />
              </FormaPolje>
            </div>

            <FormaPodskupina naslov="Drugi poslodavci" sklopiva :otvoreno.sync="otv.drugi" :kljucevi="drugiKljucevi" :model="employee">
              <div class="mreza c1">
                <FormaPolje ime="WorkForOtherCompany" :label="oz('WorkForOtherCompany')">
                  <input type="text" v-model="employee.WorkForOtherCompany" autocomplete="off" />
                </FormaPolje>
                <FormaPolje ime="WorkForOtherCompanyAbroad" :label="oz('WorkForOtherCompanyAbroad')">
                  <input type="text" v-model="employee.WorkForOtherCompanyAbroad" autocomplete="off" />
                </FormaPolje>
                <FormaPolje ime="WorkForOtherConnectedCompany" :label="oz('WorkForOtherConnectedCompany')">
                  <input type="text" v-model="employee.WorkForOtherConnectedCompany" autocomplete="off" />
                </FormaPolje>
              </div>
            </FormaPodskupina>

            <FormaPodskupina naslov="Prestanak rada" sklopiva :otvoreno.sync="otv.prestanak" :kljucevi="prestanakKljucevi" :model="employee">
              <div class="mreza">
                <FormaPolje ime="EndDateInCompany" :label="oz('EndDateInCompany')">
                  <input type="date" v-model="employee.EndDateInCompany" />
                </FormaPolje>
                <FormaPolje ime="EndReason" :label="oz('EndReason')">
                  <input type="text" v-model="employee.EndReason" autocomplete="off" />
                </FormaPolje>
              </div>
            </FormaPodskupina>
          </FormaKartica>
        </div>
      </div>
    </FormaOkvir>

    <v-container fluid v-else>
    <v-row>
      <v-col>
        <h2>
          {{lang.EmployeeCreate}}
        </h2>
      </v-col>
      <v-col class="text-right">
        <v-btn outlined color="primary" @click="promijeniIzgled('novi')">Novi obrazac</v-btn>
      </v-col>
    </v-row>
    <v-row>

      <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="pr-3">

        <v-row>
          <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
            <h3 class="text-xs-left">
              {{lang.BasicData}}  
            </h3>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
            <v-text-field
              :label="lang.hashtag"
              required
              :rules="[required]"
              v-model="employee.hashtag"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-checkbox
              :label="lang.Activ"
              v-model="employee.Activ"
            ></v-checkbox>
          </v-col>
           <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-checkbox
              :label="lang.Black"
              v-model="employee.Black"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.First"
              required
              :rules="[required]"
              v-model="employee.First"
            ></v-text-field> 
          </v-col>
           <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.Last"
              required
              :rules="[required]"
              v-model="employee.Last"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
             <v-text-field
                label="email *:"
                required
                :rules="[required]"
                v-model="employee.eemail"
              ></v-text-field>
          </v-col>
           <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
              <v-text-field
                :rules="[required]"
                label="Telefon *"
                v-model="employee.phone"
              ></v-text-field>
          </v-col>
        </v-row> 

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
          <v-text-field
              :label="lang.VatID"
              required
              :rules="[required]"
              v-model="employee.VatID"
            ></v-text-field>            
          </v-col>
           <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
             <v-text-field
              :label="lang.Gender"
              v-model="employee.Gender"
            ></v-text-field> 
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.PersonalID1"
              v-model="employee.PersonalID1"
            ></v-text-field> 
          </v-col>
           <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.PersonalID2"
              v-model="employee.PersonalID2"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
            {{lang.DateOfBirht}} <input type="date"  v-model="employee.DateOfBirht" />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
                :label="lang.PlaceOfBirht"
                v-model="employee.PlaceOfBirht"
              ></v-text-field> 
          </v-col>
           <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.PlaceOfBirthState"
              v-model="employee.PlaceOfBirthState"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.Foriner"
              v-model="employee.Foriner"
            ></v-text-field> 
          </v-col>
           <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.ForinerLicense"
              v-model="employee.ForinerLicense"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-btn
              dark
              class="blue mr-2"
              :disabled="!formIsValid"
              @click="register">
              {{langC.Save}}
            </v-btn>
          </v-col>
           <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-btn
              color="green"
              @click="employeeList">
              {{langC.Back}}
            </v-btn>
          </v-col>
        </v-row>

      </v-col>


      <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="pr-3">
        <v-row>
          <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
             <h3 class="text-xs-left">
                {{lang.AdditionalData}}
              </h3>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
            {{lang.StartInCompany}} <input type="date"  v-model="employee.StartInCompany" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="8" md="8" xs="8" lg="8" xl="8">
            <v-select
              :items="vrstaRadnogOdnosa"
              v-model="selectVrstaRadnogOdnosa"
              label="Vrsta Radnog Odnosa *"
              single-line
              item-text="text"
              item-value="value"
              return-object
              persistent-hint
              clearable
              dense
            ></v-select> 
          </v-col>
        </v-row>
        <v-row dense class="mt-0 pt-0">
          <v-col cols="12" sm="8" md="8" xs="8" lg="8" xl="8">
            <v-select
              :items="vrstaRadnogVremena"
              v-model="selectVrstaRadnogVremena"
              label="Vrsta Radnog Vremena *"
              single-line
              item-text="text"
              item-value="value"
              return-object
              persistent-hint
              clearable
              dense
              class="mt-2"
            ></v-select> 
          </v-col>
 
          <v-col cols="12" sm="4" md="4" xs="4" lg="4" xl="4">
            <v-text-field
              :label="lang.WeeklyWorkHours"
              v-model="employee.WeeklyWorkHours"
            ></v-text-field>
          </v-col>

        </v-row>

        <v-row dense>
          <v-col cols="12" sm="8" md="8" xs="8" lg="8" xl="8">
            <v-select
              :items="obrazovanje"
              v-model="selectObrazovanje"
              label="Obrazovanje *"
              single-line
              item-text="text"
              item-value="value"
              return-object
              persistent-hint
              clearable
              dense
              class="mt-2"
            ></v-select> 
          </v-col>
 
          <v-col cols="12" sm="4" md="4" xs="4" lg="4" xl="4">
            <v-text-field
              :label="lang.Degree"
              v-model="employee.Degree"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
             <v-text-field
              :label="lang.Occupation"
              v-model="employee.Occupation"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.SpecialKnowledge"
              v-model="employee.SpecialKnowledge"
            ></v-text-field>
          </v-col>
        </v-row> 

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.WorkPlace"
              v-model="employee.WorkPlace"
            ></v-text-field>
          </v-col>
          <v-col cols="8" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              label="Staž sa povećanim trajanjem Joppd 7.1 (oznaka 0 ili 1)"
              v-model="employee.Joppd71Oznaka"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row> 

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.WorkForOtherCompany"
              v-model="employee.WorkForOtherCompany"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.WorkForOtherCompanyAbroad"
              v-model="employee.WorkForOtherCompanyAbroad"
            ></v-text-field>
          </v-col>
        </v-row> 


        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.WorkForOtherConnectedCompany"
              v-model="employee.WorkForOtherConnectedCompany"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.WorkHardConditions"
              v-model="employee.WorkHardConditions"
            ></v-text-field>
          </v-col>
        </v-row> 

        <v-row dense>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            <v-text-field
              :label="lang.NotWorkingTime"
              v-model="employee.NotWorkingTime"
            ></v-text-field>
          </v-col>
        </v-row> 
        <v-row dense>
          <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
             <v-text-field
                :label="lang.PlaceOfLive"
                v-model="employee.PlaceOfLive"
              ></v-text-field>
          </v-col>
        </v-row>

          
      </v-col>


      <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">

        <v-row>
          <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
            <h3 class="text-xs-left">
              {{lang.InternalNotes}}        
            </h3>
          </v-col>
        </v-row> 

        <v-row>
          <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
            <v-textarea
              :label="lang.OtherData"
              v-model="employee.OtherData"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
            {{lang.EndDateInCompany}} <input type="date"  v-model="employee.EndDateInCompany" />
          </v-col>
        </v-row> 

        <v-row>
          <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
            <v-text-field
              :label="lang.EndReason"
              v-model="employee.EndReason"
            ></v-text-field>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </v-container>
  </div>

</template>

<script>
import EmployeeService from '@/services/EmployeeService'
import langEn from './empDescEn'
import langHr from './empDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import FormaOkvir from './forma/FormaOkvir'
import FormaTraka from './forma/FormaTraka'
import FormaTabovi from './forma/FormaTabovi'
import FormaKartica from './forma/FormaKartica'
import FormaPodskupina from './forma/FormaPodskupina'
import FormaPolje from './forma/FormaPolje'
import {
  citajIzgled, spremiIzgled, kloniraj, izmijenjenaPolja, validiraj, brojPopunjenih,
  oibUpozorenje, emailUpozorenje, krajPrijePocetka, hashtagTrebaProvjeru, jednako, cistaOznaka, porukaIzGreske
} from './forma/formaLogika'

const OSOBNI = ['First', 'Last', 'VatID', 'DateOfBirht', 'Gender', 'PersonalID1', 'PersonalID2', 'PlaceOfBirht', 'PlaceOfBirthState', 'Foriner', 'ForinerLicense']
const KONTAKT = ['eemail', 'phone', 'PlaceOfLive']
const DRUGI = ['WorkForOtherCompany', 'WorkForOtherCompanyAbroad', 'WorkForOtherConnectedCompany']
const PRESTANAK = ['EndDateInCompany', 'EndReason']
const ZAPOSLENJE = ['hashtag', 'Activ', 'Black', 'StartInCompany', 'WeeklyWorkHours', 'VrstaRadnogOdnosa', 'VrstaRadnogVremena', 'NotWorkingTime',
  'Joppd71Oznaka', 'WorkHardConditions', 'WorkPlace', 'Occupation', 'Obrazovanje', 'Degree', 'SpecialKnowledge'].concat(DRUGI, PRESTANAK)
const OSTALO = ['OtherData']
// sva polja forme (35), redom kako su na ekranu
const SVA_POLJA = OSOBNI.concat(KONTAKT, ZAPOSLENJE, OSTALO)
const OBAVEZNA = {
  hashtag: 'Obavezno polje', First: 'Obavezno polje', Last: 'Obavezno polje', VatID: 'Obavezno polje',
  eemail: 'Obavezno polje', phone: 'Obavezno polje', DateOfBirht: 'Obavezno polje',
  VrstaRadnogOdnosa: 'Odaberite vrstu radnog odnosa', VrstaRadnogVremena: 'Odaberite vrstu radnog vremena', Obrazovanje: 'Odaberite obrazovanje'
}

export default {
  name: 'employeecreate',
  components: { FormaOkvir, FormaTraka, FormaTabovi, FormaKartica, FormaPodskupina, FormaPolje },
  data () {
    return {
      noviIzgled: citajIzgled('employeeCreateIzgled') === 'novi',
      izvornik: null,
      ucitano: false,
      pokusaj: false,
      spremanje: false,
      otv: { ostalo: false, drugi: false, prestanak: false },
      hashtagStanje: { status: '', poruka: '', preklapanja: [] },
      hashtagPredlaganje: false,
      hashtagHintTekst: '',
      hashtagBr: 0,
      hashtagTimer: null,
      osobniKljucevi: OSOBNI,
      kontaktKljucevi: KONTAKT,
      zaposlenjeKljucevi: ZAPOSLENJE,
      ostaloKljucevi: OSTALO,
      drugiKljucevi: DRUGI,
      prestanakKljucevi: PRESTANAK,
      redoslijed: ['First', 'Last', 'VatID', 'DateOfBirht', 'eemail', 'phone', 'hashtag', 'VrstaRadnogOdnosa', 'VrstaRadnogVremena', 'Obrazovanje'],
      lang: {},
      langC: {},
      menu: false,
      menu2: false,
      menu3: false,
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      dialog: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      msg: '',
      obrazovanje: [],
      selectObrazovanje: {},
      vrstaRadnogOdnosa: [],
      selectVrstaRadnogOdnosa: {},
      vrstaRadnogVremena: [],
      selectVrstaRadnogVremena: {},
      newEmployee: {},
      employee: {},
      required: (value) => !!value || 'Required.',
      error: ''
    }
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = langEn
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = langHr
      this.langC = commHr;
    }
    this.obrazovanje = this.$store.state.obrazovanje
    this.vrstaRadnogOdnosa = this.$store.state.vrstaRadnogOdnosa
    this.vrstaRadnogVremena = this.$store.state.vrstaRadnogVremena
    if (this.$store.state.editItem === 1) {
      if (!this.$store.state.employeeid) {
        this.employeeList()
        return
      }
      await EmployeeService.show(this.$store.state.employeeid)
      .then(res => {   
        this.employee = res.data.employee
        this.selectObrazovanje = this.employee.Obrazovanje ? this.obrazovanje.find(obr => obr.value === parseInt(this.employee.Obrazovanje)) : null
        this.selectVrstaRadnogOdnosa = this.employee.VrstaRadnogOdnosa ? this.vrstaRadnogOdnosa.find( vrO => vrO.value === parseInt(this.employee.VrstaRadnogOdnosa)) : null
        this.selectVrstaRadnogVremena = this.employee.VrstaRadnogVremena ? this.vrstaRadnogVremena.find( vrV => vrV.value === parseInt(this.employee.VrstaRadnogVremena)) : null
        }
      )
      .catch(err => {
        console.log('err', err)
      })
    }
    this.pokreniNoviObrazac()
  },
  beforeDestroy () {
    clearTimeout(this.hashtagTimer)
  },
  methods: {
    // ---- novi obrazac ----
    async pokreniNoviObrazac () {
      if (this.$store.state.editItem === 0 && this.noviIzgled) {
        // Početne vrijednosti novog radnika (forma ih ranije nije postavljala; WeeklyWorkHours je ujedno zadano u modelu)
        this.$set(this.employee, 'Activ', true)
        this.$set(this.employee, 'WeeklyWorkHours', 40)
      }
      await this.$nextTick() // pusti da watcheri izbornika upišu Obrazovanje / vrste
      this.izvornik = kloniraj(this.employee)
      this.otv.ostalo = brojPopunjenih(this.employee, OSTALO) > 0
      this.otv.drugi = brojPopunjenih(this.employee, DRUGI) > 0
      this.otv.prestanak = brojPopunjenih(this.employee, PRESTANAK) > 0
      this.ucitano = true
    },
    oz (k) {
      return cistaOznaka(this.lang[k])
    },
    promijeniIzgled (izgled) {
      this.noviIzgled = izgled === 'novi'
      spremiIzgled('employeeCreateIzgled', izgled)
    },
    odustani () {
      if (this.izmijenjena.length && !window.confirm('Ima nespremljenih izmjena. Odustati bez spremanja?')) return
      if (this.$store.state.editItem === 0) {
        this.$router.push({ name: 'employee' })
      } else {
        this.employeeList()
      }
    },
    async spremiNovi () {
      this.pokusaj = true
      this.error = ''
      await this.$nextTick()
      if (Object.keys(this.validacija.greske).length) {
        if (this.$refs.okvir) this.$refs.okvir.skociNaPrvu()
        return
      }
      this.spremanje = true
      try {
        await this.register()
      } finally {
        this.spremanje = false
      }
    },
    zakaziProvjeruHashtaga () {
      clearTimeout(this.hashtagTimer)
      const h = this.employee.hashtag
      const neProvjeravaj = !this.ucitano || !hashtagTrebaProvjeru(h) || (this.izvornik && jednako(h, this.izvornik.hashtag))
      if (neProvjeravaj) {
        this.hashtagBr++
        this.hashtagStanje = { status: '', poruka: '', preklapanja: [] }
        return
      }
      this.hashtagStanje = { status: 'provjera', poruka: '', preklapanja: [] }
      const br = ++this.hashtagBr
      this.hashtagTimer = setTimeout(async () => {
        try {
          const res = await EmployeeService.hashtagProvjera({
            hashtag: String(h).trim(),
            VatID: this.employee.VatID || '',
            EmployeeId: this.employee.id || ''
          })
          if (br !== this.hashtagBr) return
          const d = res.data || {}
          const pre = d.preklapanja || []
          const imeFirme = (x) => (x.firma ? ' (' + x.firma + ')' : '')
          if (d.slobodan === false) {
            const drugi = pre.filter(x => !x.istaOsoba)
            this.hashtagStanje = {
              status: 'zauzet',
              poruka: 'Već koristi drugi radnik: ' + (drugi.length ? drugi.map(x => x.First + ' ' + x.Last + imeFirme(x)).join('; ') : 'drugi radnik'),
              preklapanja: pre
            }
          } else {
            const ista = pre.filter(x => x.istaOsoba)
            this.hashtagStanje = ista.length
              ? { status: 'ista', poruka: 'Isti radnik radi i u firmi ' + ista.map(x => x.firma || ('#' + x.CompanyId)).join(', '), preklapanja: pre }
              : { status: 'slobodan', poruka: '', preklapanja: pre }
          }
        } catch (e) {
          // ruta nedostupna ili mrežna greška: ne blokiraj, server će ionako provjeriti pri spremanju
          if (br === this.hashtagBr) this.hashtagStanje = { status: '', poruka: '', preklapanja: [] }
        }
      }, 500)
    },
    async predloziHashtag () {
      if (!this.mozePredloziti) return
      this.hashtagPredlaganje = true
      try {
        const res = await EmployeeService.hashtagPrijedlog({
          First: this.employee.First || '',
          Last: this.employee.Last || '',
          VatID: this.employee.VatID || '',
          EmployeeId: this.employee.id || ''
        })
        const d = res.data || {}
        if (d.prijedlog) {
          this.$set(this.employee, 'hashtag', d.prijedlog)
          this.hashtagHintTekst = d.razlog || ''
        }
      } catch (e) {
        this.hashtagHintTekst = 'Prijedlog trenutno nije dostupan.'
      } finally {
        this.hashtagPredlaganje = false
      }
    },
    // ---- postojeće metode (stari obrazac) ----
    async register () {
      try {
        if (this.$store.state.user.id) {
          this.employee.UserId = this.$store.state.user.id
        }
        if (this.$store.state.user.email) {
          this.employee.email = this.$store.state.user.email
          this.employee.LastUpdateBy = this.$store.state.user.email
        }
        if (this.$store.state.companyid) {
          this.employee.CompanyId = this.$store.state.companyid
        }
        if (this.$store.state.companyName) {
          this.employee.CompanyNameDatabase = this.$store.state.companyName
        }
        if (this.$store.state.busniessYear) {
          this.employee.BusinessYear = this.$store.state.busniessYear
        }
        if (this.$store.state.editItem === 0) {
          await EmployeeService.post(this.employee)
          this.$router.push({
            name: 'employee'
          })
        }
        if (this.$store.state.editItem === 1) {
          await EmployeeService.put(this.employee)
          this.$router.push({
            name: 'employeeview'
          })
        }
        
      } catch (error) {
        this.error = porukaIzGreske(error)
      }
    },
    async employeeList () {
      try {
        await this.$router.push({
          name: 'employeeview'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    save (date) {
      this.$refs.menu.save(date)
    },
    doFlap1 () {
      if (this.employee.Activ === true) {
        this.employee.Black = false
      }
    },
    doFlap2 () {
      if (this.employee.Black === true) {
        this.employee.Activ = false
      }
    }
  },
  computed: {
    izmijenjena () {
      return izmijenjenaPolja(this.izvornik, this.employee, SVA_POLJA)
    },
    validacija () {
      return validiraj(this.employee, {
        obavezna: OBAVEZNA,
        greske: {
          hashtag: () => (this.hashtagStanje.status === 'zauzet' ? this.hashtagStanje.poruka : null)
        },
        upozorenja: {
          VatID: oibUpozorenje,
          eemail: emailUpozorenje,
          EndDateInCompany: (v, m) => krajPrijePocetka(m.StartInCompany, v)
        }
      })
    },
    // prije pokušaja spremanja vidi se samo "hashtag zauzet"; nakon pokušaja sve greške (uživo)
    greskeVidljive () {
      if (this.pokusaj) return this.validacija.greske
      const g = {}
      if (this.validacija.greske.hashtag && this.hashtagStanje.status === 'zauzet') g.hashtag = this.validacija.greske.hashtag
      return g
    },
    hashtagKljuc () {
      return String(this.employee.hashtag || '') + '|' + String(this.employee.VatID || '')
    },
    mozePredloziti () {
      return !!(String(this.employee.First || '').trim() && String(this.employee.Last || '').trim())
    },
    hashtagHint () {
      return this.hashtagHintTekst || (this.mozePredloziti ? '' : 'Za prijedlog upiši ime i prezime')
    },
    porukaServera () {
      return this.error ? String(this.error) : ''
    },
    naslovTrake () {
      if (this.$store.state.editItem === 0) return 'Novi radnik'
      const ime = ((this.employee.First || '') + ' ' + (this.employee.Last || '')).trim()
      return ime || 'Uređivanje radnika'
    },
    podnaslovTrake () {
      if (this.$store.state.editItem === 0) return 'Unos · polja označena zvjezdicom su obavezna'
      return ['Uređivanje', this.employee.VatID ? 'OIB ' + this.employee.VatID : '', this.employee.hashtag || ''].filter(x => x).join(' · ')
    },
    inicijali () {
      const a = String(this.employee.First || '').trim().charAt(0)
      const b = String(this.employee.Last || '').trim().charAt(0)
      return (a + b).toUpperCase() || '+'
    },
    tabovi () {
      return [
        { id: 'k-osobni', naslov: 'Osobni', kljucevi: OSOBNI },
        { id: 'k-kontakt', naslov: 'Kontakt', kljucevi: KONTAKT },
        { id: 'k-zaposlenje', naslov: 'Zaposlenje', kljucevi: ZAPOSLENJE },
        { id: 'k-ostalo', naslov: 'Ostalo', kljucevi: OSTALO }
      ]
    },
    formIsValid () {
      return this.employee.eemail !== '' &&
        this.employee.hashtag !== '' &&
        this.employee.First !== '' &&
        this.employee.Last !== '' &&
        this.employee.VatID !== ''
    }
  },
  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    hashtagKljuc () {
      this.zakaziProvjeruHashtaga()
    },
    'employee.Activ' () {
      this.doFlap1()
    },
    'employee.Black' () {
      this.doFlap2()
    },
    'selectObrazovanje' () {
      this.$set(this.employee, 'Obrazovanje', this.selectObrazovanje ? this.selectObrazovanje.value : null)
    },
    'selectVrstaRadnogOdnosa' () {
      this.$set(this.employee, 'VrstaRadnogOdnosa', this.selectVrstaRadnogOdnosa ? this.selectVrstaRadnogOdnosa.value : null)
    },
    'selectVrstaRadnogVremena' () {
      this.$set(this.employee, 'VrstaRadnogVremena', this.selectVrstaRadnogVremena ? this.selectVrstaRadnogVremena.value : null)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
